export interface PersonTotalJson {
  not_associates_or_directors: number;
}

export class PersonTotal {
  constructor(public notAssociatesOrDirectors?: number) {}

  static fromJson(json: Partial<PersonTotalJson>): PersonTotal {
    return new PersonTotal(json.not_associates_or_directors);
  }
}
